import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, CompassIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="top" className="relative flex min-h-[760px] w-full items-end overflow-hidden bg-[#172a27] text-white" data-id="element-145" data-mp="eilc6zjmglae">
      <img src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=2200&q=90" alt="Snow-covered Himalayan peaks above the Manaslu region" className="absolute inset-0 h-full w-full object-cover" data-id="element-146" data-mp="4lyswf6y22ah" />
      <div className="absolute inset-0 bg-[#0a1715]/55" data-id="element-147" data-mp="xb5rfe6eervq" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-[linear-gradient(to_top,rgba(9,24,21,.90),transparent)]" data-id="element-148" data-mp="sai2qz5n6n4o" />
      <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-40 sm:px-8 lg:px-10 lg:pb-20" data-id="element-149" data-mp="nbewjbdxeav4">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-150" data-mp="3d2birmcv0tty">
          <div className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#D9CAA0]" data-id="element-151" data-mp="3o73pmcpadw8l">
            <span className="h-px w-10 bg-[#D9CAA0]" data-id="element-152" data-mp="39cfkiznsszti" />
            Nepal’s quieter giant
          </div>
          <h1 className="font-display text-5xl leading-[0.95] sm:text-6xl lg:text-8xl" data-id="element-153" data-mp="3eb90qzugz4xd">
            Walk the wild
            <br data-id="element-154" data-mp="358rdci32w68s" />
            side of <em className="font-normal text-[#D9CAA0]" data-id="element-155" data-mp="358zp26ngt5ie">Manaslu.</em>
          </h1>
          <p className="mt-7 max-w-xl text-base leading-7 text-stone-200 sm:text-lg" data-id="element-156" data-mp="2qk3lomwcsgo4">
            Ten deeply considered days through river gorges, Tibetan-influenced
            villages, and the immense shadow of the world’s eighth-highest
            mountain.
          </p>
          <div className="mt-9 flex flex-wrap gap-4" data-id="element-157" data-mp="2hlj983hdz38c">
            <a href="#inquiry" className="inline-flex items-center gap-2 bg-[#A48C5A] px-6 py-4 text-sm font-bold text-[#152622] transition-colors hover:bg-[#D9CAA0]" data-id="element-158" data-mp="2ljgy1578vnb7">
              Find your departure{' '}
              <ArrowRightIcon size={17} aria-hidden="true" data-id="element-159" data-mp="ic85x8ls7uuo" />
            </a>
            <a href="#guide" className="inline-flex items-center gap-2 border border-white/50 px-6 py-4 text-sm font-bold text-white transition-colors hover:border-[#D9CAA0] hover:text-[#D9CAA0]" data-id="element-160" data-mp="ici0zaloos78">
              Explore the guide <CompassIcon size={17} aria-hidden="true" data-id="element-161" data-mp="161jc55lwihg7" />
            </a>
          </div>
        </motion.div>
        <div className="mt-16 flex flex-wrap border-t border-white/25 pt-6 sm:mt-20 sm:gap-14" data-id="element-162" data-mp="111oln361ftvo">
          {[['10', 'days in Nepal'], ['5,106m', 'highest point'], ['1:4', 'guide ratio']].map(([value, label]) => <div key={label} className="mr-10 mt-3" data-id="element-163" data-mp="3hrlm2muo2fb3">
              <div className="font-display text-2xl text-[#D9CAA0]" data-id="element-164" data-mp="3hpsff7k1zv33">
                {value}
              </div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-stone-300" data-id="element-165" data-mp="1xb5mo58pibbw">
                {label}
              </div>
            </div>)}
          <a href="#guide" className="ml-auto mt-3 hidden items-center gap-2 text-sm text-stone-200 lg:inline-flex" data-id="element-166" data-mp="268y71ntac965">
            Scroll to discover <ArrowDownIcon size={16} aria-hidden="true" data-id="element-167" data-mp="2g02jogvhnhxt" />
          </a>
        </div>
      </div>
    </section>;
}